module.exports = __webpack_public_path__ + "static/media/expected_date_icon_1-01.658999f4.svg";